/**
 * 需求来源：docs/旅游落地页/AI提示词.md 第1次提交 需求4（任务单 DEV-120352）；视觉基准 docs/旅游落地页/cj商旅-01.html。
 * 注意事项：
 * 1. 集中原型内所有内联 SVG 图标（原型未给 svg 内联属性，描边/填充全部由各区块 CSS 的
 *    `svg { fill:none; stroke:currentColor; ... }` 规则决定，故此处同样只给 viewBox + path，
 *    不写死 stroke/fill，避免覆盖样式导致与原型不一致）。
 * 2. aria-hidden 与原型保持一致（图标均为装饰性，语义由相邻文本/aria-label 承担）。
 */
import React from 'react';

/** 通用右箭头（原型 CTA/按钮/tab 均复用同一组 path）。 */
export function ArrowRight() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 12h14"></path>
      <path d="m13 6 6 6-6 6"></path>
    </svg>
  );
}

/** 左箭头（图库上一组）。 */
export function ArrowLeft() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5"></path>
      <path d="m11 18-6-6 6-6"></path>
    </svg>
  );
}

/** 圆圈对勾（Hero 底部信任条）。 */
export function CheckCircle() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"></path>
      <path d="m9 12 2 2 4-5"></path>
    </svg>
  );
}

/** 时钟（Route Planner 标题图标）。 */
export function Clock() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"></path>
      <path d="M12 7v5l3 2"></path>
    </svg>
  );
}

/** 交通（Services 卡片 01）。 */
export function IconTransport() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 17h16"></path>
      <path d="M6 17V8h12v9"></path>
      <path d="M8 8 10 4h4l2 4"></path>
      <path d="M8 20h.01"></path>
      <path d="M16 20h.01"></path>
      <path d="M8 12h8"></path>
    </svg>
  );
}

/** 酒店（Services 卡片 02）。 */
export function IconHotel() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 19h16"></path>
      <path d="M6 19V7h12v12"></path>
      <path d="M9 7V4h6v3"></path>
      <path d="M9 11h2"></path>
      <path d="M13 11h2"></path>
      <path d="M9 15h2"></path>
      <path d="M13 15h2"></path>
    </svg>
  );
}

/** 指南针（Services 卡片 03 观光）。 */
export function IconSightseeing() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"></path>
      <path d="m15.5 8.5-2 5-5 2 2-5Z"></path>
    </svg>
  );
}

/** 左右拖拽提示（图库底部说明）。 */
export function IconDrag() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M8 12h8"></path>
      <path d="m11 9-3 3 3 3"></path>
      <path d="m13 9 3 3-3 3"></path>
    </svg>
  );
}

/** Services 图标按名取用。 */
export function ServiceIcon(props) {
  if (props.name === 'transport') return <IconTransport />;
  if (props.name === 'hotel') return <IconHotel />;
  return <IconSightseeing />;
}
